import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetRemoteLockUserDevicesRequest = {
  clientId: string
}

export type RemoteLockDevice = {
  id: string
  name: string
  serialNumber?: string
}

export type RemoteLockUserDevicesResponse = {
  id: string
  remoteLockId: string
  buildingId: number
  email: string
  accesses: RemoteLockDevice[]
  fobIssuedAt?: string | number | null
}

export const getRemoteLockUserDevicesQueryKey = (data: GetRemoteLockUserDevicesRequest) => [
  'useGetRemoteLockUserDevices',
  data,
]

const getRemoteLockUserDevices = async (data: GetRemoteLockUserDevicesRequest) => {
  const response = await authAPI.get<RemoteLockUserDevicesResponse>(
    `/remote-lock/users/${data.clientId}`,
  )
  return response.data
}

export const useGetRemoteLockUserDevices = (
  data: GetRemoteLockUserDevicesRequest,
  enabled = true,
) =>
  useQuery({
    enabled: enabled && Boolean(data.clientId),
    queryFn: () => getRemoteLockUserDevices(data),
    queryKey: getRemoteLockUserDevicesQueryKey(data),
  })
